var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8634 3.5497L11.4089 1.04009C10.8634 0.482394 10.0907 0.157074 9.31799 0.157074H5.45436C4.68164 0.157074 3.90891 0.482394 3.36346 1.04009L0.908922 3.5497C0.36347 4.10739 0.0452881 4.89746 0.0452881 5.68752V9.59136C0.0452881 10.3814 0.36347 11.1715 0.908922 11.7292L3.86346 14.75C4.04528 14.9359 4.13618 15.1683 4.13618 15.4471V16.6555C4.13618 17.3526 4.68164 17.9103 5.36345 17.9103H9.27253C9.95435 17.9103 10.4998 17.3526 10.4998 16.6555V15.4936C10.4998 15.2612 10.5907 14.9824 10.7725 14.7965L13.818 11.7292C14.3634 11.1715 14.6816 10.3814 14.6816 9.59136V5.68752C14.7725 4.89746 14.4543 4.15387 13.8634 3.5497ZM11.6362 9.08014C11.6362 9.49841 11.4998 9.87021 11.2271 10.1955L10.0453 11.4968C9.63617 11.9151 9.54526 12.5657 9.77253 13.1234L10.4543 14.843H4.40891L5.09073 13.1234C5.318 12.5657 5.18164 11.9616 4.818 11.4968L3.63619 10.1955C3.36346 9.91668 3.2271 9.49841 3.2271 9.08014V6.24521C3.2271 5.82694 3.36346 5.45515 3.63619 5.1763L4.95436 3.64265C5.27254 3.31733 5.68163 3.08496 6.13618 3.08496H8.72708C9.18162 3.08496 9.59071 3.27085 9.90889 3.64265L11.2725 5.1763C11.5453 5.45515 11.6816 5.87342 11.6816 6.29169V9.08014H11.6362Z",
    fill: "#3F7CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.03cfb69d66a133ccbad88a5845770d9d.svg";
export { ForwardRef as ReactComponent };